import React, { useState } from "react";
import Layout from "../components/Layout";

function DownloadCertificate() {
  const [email, setEmail] = useState("");
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const API = process.env.REACT_APP_API_URL;

  const getLinkedInCaption = (cert) => {
    return `Excited to complete my ${cert.domain} internship with Syntriq 🚀
  
  Hands-on learning, real-world projects, and practical experience.
  
  🔍 Verify my certificate here:
  https://certificates.syntriq.in/verify/${cert.certificate_id}
  
  #SyntriqInternship #CareerGrowth #Internship @Syntriq`;
  };

  const copyCaption = async (cert) => {
    try {
      await navigator.clipboard.writeText(getLinkedInCaption(cert));
      alert("Caption copied! Paste it on LinkedIn ✨");
    } catch (err) {
      alert("Failed to copy caption. Please copy manually.");
    }
  };

  const getLinkedInShareUrl = (cert) => {
    const caption = `
Excited to complete my ${cert.domain} internship with Syntriq 🚀

Hands-on learning, real-world projects, and practical experience.

🔗 Certificate verified here:
https://syntriq.in/verify/${cert.certificate_id}

#SyntriqInternship #Internship #CareerGrowth @Syntriq 
    `;

    return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      cert.certificate_url
    )}&title=${encodeURIComponent(caption)}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      alert("Please enter your registered email");
      return;
    }

    setLoading(true);
    setError(null);
    setCertificates([]);

    try {
      const res = await fetch(`${API}/api/certificates/by-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      console.log("API Response:", data);
      console.log("Certificates:", data.certificates);

      if (!data.success || data.certificates.length === 0) {
        setError("No certificates available yet for this email.");
        return;
      }

      data.certificates.forEach((cert) => {
        console.log(
          `Cert ${cert.certificate_id}: payment_status = "${
            cert.payment_status
          }" (type: ${typeof cert.payment_status})`
        );
      });

      setCertificates(data.certificates);
    } catch (err) {
      setError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="page-header reveal reveal-up">
          <div className="page-badge">
            <span className="float-soft" style={{ display: 'inline-block' }}>📥</span> Certificate Portal
          </div>
          <h1 className="page-title">
            <span className="gradient-text">Download Certificate</span>
          </h1>
          <p className="page-subtitle">
            Enter your registered email to view and download your certificates
          </p>
        </div>

        <div className="card reveal reveal-up stagger-2 shimmer-border" style={{ position: 'relative' }}>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Registered Email Address</label>
              <input
                type="email"
                className="form-input"
                placeholder="your.email@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
            </div>

            <button className="btn btn-primary" disabled={loading}>
              {loading ? (
                <>
                  <span className="loading-spinner" /> Searching…
                </>
              ) : (
                "🔎 Find My Certificates"
              )}
            </button>
          </form>

          {error && (
            <div className="result-card error mt-3">
              <div className="result-icon">❌</div>
              <p style={{ fontWeight: 600, color: '#dc2626' }}>{error}</p>
            </div>
          )}

          {certificates.length > 0 && (
            <div className="certificates-list mt-3">
              <h2 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span>🎓</span> Your Certificates
                <span style={{
                  fontSize: '0.8rem',
                  padding: '0.2rem 0.6rem',
                  borderRadius: '9999px',
                  background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
                  color: '#fff',
                  fontWeight: 700,
                }}>
                  {certificates.length}
                </span>
              </h2>

              {certificates.map((cert, index) => (
                <div
                  key={`${cert.certificate_id}-${cert.created_at}`}
                  className="result-card success mt-3"
                  style={{ animationDelay: `${index * 150}ms` }}
                >
                  <h3 style={{ fontSize: '1.15rem', fontWeight: 700, color: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
                    <span style={{ fontSize: '1.25rem' }}>📜</span> {cert.domain}
                  </h3>

                  <div className="result-details">
                    <div className="detail-row">
                      <span>Batch:</span>
                      <span>{cert.batch}</span>
                    </div>
                    <div className="detail-row">
                      <span>Certificate ID:</span>
                      <span style={{ fontFamily: "'Courier New', monospace", fontSize: '0.85rem' }}>{cert.certificate_id}</span>
                    </div>
                  </div>

                  {String(cert.payment_status).toLowerCase() === "paid" ? (
                    <div style={{ marginTop: '1rem' }}>
                      <button
                        className="btn btn-primary mt-2"
                        onClick={() =>
                          window.open(cert.certificate_url, "_blank")
                        }
                      >
                        📥 Download Certificate
                      </button>
                      <a
                        href={getLinkedInShareUrl(cert)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-linkedin mt-2"
                      >
                        🔗 Share Certificate on LinkedIn
                      </a>

                      <p style={{ fontSize: "0.8rem", marginTop: "0.5rem", color: "#64748b", textAlign: "center" }}>
                        Tag <strong>@Syntriq</strong> to get featured ✨
                      </p>
                      <button
                        className="btn btn-copy mt-2"
                        onClick={() => copyCaption(cert)}
                      >
                        📋 Copy Professional LinkedIn Caption
                      </button>

                      <p style={{ fontSize: "0.75rem", marginTop: "0.4rem", color: "#64748b", textAlign: "center" }}>
                        Paste the caption after LinkedIn opens
                      </p>
                    </div>
                  ) : (
                    <div className="mt-3" style={{
                      padding: '1.25rem',
                      borderRadius: '0.875rem',
                      background: 'linear-gradient(135deg, rgba(241,245,249,.9), rgba(248,250,252,.9))',
                      border: '1px solid rgba(226,232,240,.5)',
                      marginTop: '1rem',
                    }}>
                      <p style={{ fontWeight: 700, color: '#0f172a', fontSize: '0.95rem' }}>
                        💪 Please support our hard working Team
                      </p>
                      <p style={{ fontSize: "0.85rem", color: "#64748b", marginTop: '0.5rem', lineHeight: 1.7 }}>
                        This small contribution helps us appreciate the efforts
                        of our mentors, reviewers, and support team.
                      </p>
                      <p style={{ marginTop: '0.75rem', fontSize: '1.1rem', fontWeight: 800, color: '#0f172a' }}>
                        Contribution: <span style={{ background: 'linear-gradient(135deg, #2563eb, #7c3aed)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>₹99</span>
                      </p>

                      <button
                        className="btn btn-secondary mt-2"
                        onClick={() =>
                          (window.location.href =
                            `/payment?certId=${cert.certificate_id}` +
                            `&name=${encodeURIComponent(cert.name)}` +
                            `&email=${encodeURIComponent(email)}` +
                            `&domain=${encodeURIComponent(cert.domain)}`)
                        }
                      >
                        🤝 Pay & Download Certificate
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Trust bar */}
        <div className="reveal reveal-up stagger-3" style={{ display: 'flex', justifyContent: 'center', gap: '2rem', marginTop: '1.5rem', flexWrap: 'wrap' }}>
          {['🔒 Secure Downloads', '📧 Email Verified', '✨ Instant Access'].map((item) => (
            <div key={item} style={{
              fontSize: '0.8rem', color: '#64748b', fontWeight: 500,
              display: 'flex', alignItems: 'center', gap: '0.25rem',
              padding: '0.375rem 0.75rem', borderRadius: '9999px',
              background: 'rgba(255,255,255,.6)', border: '1px solid rgba(226,232,240,.5)',
              backdropFilter: 'blur(8px)',
            }}>
              {item}
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export default DownloadCertificate;
